import { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, A11y } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import './profile-cover.css';

/**
 * Portada de la página de una modelo.
 *
 * Imagen grande a todo el ancho que ocupa la parte superior de la página. Si
 * la modelo tiene portada propia se usa esa; si no, se recurre a sus fotos
 * publicadas para que el perfil nunca quede sin impacto visual.
 *
 * Con varias imágenes se alternan con un fundido lento: es una portada, no un
 * carrusel para navegar, así que no lleva flechas ni miniaturas.
 */
export default function ProfileCover({ cover, photos = [], name, children }) {
    // Una portada explícita manda sobre la galería.
    const imagenes = useMemo(() => {
        if (cover) return [{ id: 'cover', src: cover, alt: `Portada de ${name}` }];
        return photos.slice(0, 5);
    }, [cover, photos, name]);

    const rotar = imagenes.length > 1;

    return (
        <header className="profile-cover">
            <div className="profile-cover-media">
                {imagenes.length === 0 ? (
                    <div className="profile-cover-empty" aria-hidden="true"></div>
                ) : rotar ? (
                    <Swiper
                        modules={[Autoplay, EffectFade, A11y]}
                        effect="fade"
                        fadeEffect={{ crossFade: true }}
                        speed={1200}
                        loop
                        allowTouchMove={false}
                        autoplay={{ delay: 5000, disableOnInteraction: false }}
                        className="profile-cover-swiper"
                    >
                        {imagenes.map((img) => (
                            <SwiperSlide key={img.id}>
                                <img src={img.src} alt={img.alt} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <img src={imagenes[0].src} alt={imagenes[0].alt} />
                )}
            </div>

            {/* Degradado solo en la mitad inferior: la portada se ve, y el
                texto sobrepuesto sigue siendo legible. */}
            <div className="profile-cover-scrim" aria-hidden="true"></div>

            <div className="container profile-cover-content">{children}</div>
        </header>
    );
}
